import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import moment from "moment";
import { ActionSection, EditButton, ModalHeader, ModalSection, ModalSectionTitle, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import { CircularProgress } from "@mui/material";
import { capitalizeFirstLetter, getDueIcon, getDueLabel } from "../../helpers";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Config from "../../Config";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { MdOutlineAccountBalance, MdOutlinePayments } from "react-icons/md";

const ViewFinalDues = ({
    setIsShowFinalDuesModal,
    apiData,
    dueListData,
    dueListLoading,
    editDueLoading,
    editDueMutate,
    tenantId,
    onSubmit,
    isGenerating,
    setIsAddDuesModal,
    setShowOfflineRefundModal,
    setShowOnlineRefundModal,
    getListMutate
}) => {
    const refundStatus = apiData?.occupancy?.refundStatus || Config.REFUND_STATUS.PENDING;

    const isRefundDisabled = (dueListData?.data?.data?.totalRefund ?? 0) < 1 ||
        refundStatus === Config.REFUND_STATUS.INITIATED;
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedValue, setEditedValue] = useState("");
    const [dueEditId, setDueEditId] = useState(null);
    const [isFabOpen, setIsFabOpen] = useState(false);
    const isPayoutEnabled = useSelector((state) => state.IsPayoutEnabledReducer.isPayoutEnabled);

    const due = dueListData?.data?.data?.pendingDues || []
    const securityAdjustedDues = dueListData?.data?.data?.securityAdjustedDues || []
    const dues = due.map((item) => ({
        label: getDueLabel(item.type),
        amount: item?.balance || 0,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
        title: item.title,
        type: item.type
    }))
    const securityAdjusted = securityAdjustedDues.map((item) => ({

        label: getDueLabel(item.type),
        amount: item.amount,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
        title: item.title,
        type: item.type
    }))
    const totalPendingDueAmount = dueListData?.data?.data?.totalPendingDueAmount || 0;
    const totalAdjustedDueAmount = dueListData?.data?.data?.totalAdjustedDueAmount || 0;
    const handleEditClick = (dueId, amount, index) => {
        if (editingIndex === index) {
            setEditingIndex(null)
        } else {
            setEditingIndex(index)
            setEditedValue(amount)
            setDueEditId(dueId)
        }
    }

    const handleEditSubmit = () => {
        if (editedValue > 1000000) {
            toast.error("Amount cannot be greater than 10,00,000");
            return;
        }
        editDueMutate({
            id: dueEditId,
            balance: parseInt(editedValue),
            isTemp: false,
            tenantId: tenantId,
            isEvicted: false,
        });
        setEditingIndex(null);

    };
    const onClose = () => {
        setIsShowFinalDuesModal(false);
        // getListMutate()
    };
    const totalDues = totalPendingDueAmount + Math.abs(totalAdjustedDueAmount);
    const handleSubmit = () => {
        if (onSubmit) {
            onSubmit();
        }
    };
    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Final Summary</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ModalProfileHeader
                title="Final Summary"
                name={capitalizeFirstLetter(apiData?.name)}
                subtitle={`#${apiData?.occupancy?.roomNum} • ${apiData?.occupancy?.flatName} • ${apiData?.occupancy?.propName}`}
                amountLabel={"Security Paid"}
                amount={dueListData?.data?.data?.securityPaid}
                image={''}
                onClose={onClose}
            />

            {/* <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {apiData?.name}
                    </span>
                    <span className="text-sm text-gray-600">
                        {"#" + apiData?.occupancy?.roomNum || "N/A"},{" "}
                        {apiData?.occupancy?.flatName || "N/A"},{" "}
                        {apiData?.occupancy?.propName}
                    </span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className="text-gray-500 text-sm">{"Security Paid"}</span>
                    <span className="text-xl font-semibold text-gray-700">
                        {'₹' + dueListData?.data?.data?.securityPaid}
                    </span>
                </div>
            </ProfileSection> */}
            {dueListLoading && (
                <div className="flex justify-center items-center my-40">
                    <CircularProgress size={40} />
                </div>
            )}
            <Content>
                <ScrollableContent>
                    <Wrapper>
                        {!dueListLoading && dueListData && (
                            <>
                                {/* Pending Dues Section */}
                                {/* <SectionBox> */}
                                {/* <SectionHeader className="flex justify-between items-center">
                                        <SectionTitle>Pending Dues</SectionTitle>
                                        <button type="button" className="text-primary-color text-sm underline" onClick={() => setIsAddDuesModal(true)}>Add Dues</button>
                                    </SectionHeader> */}
                                <BtnWrapper>
                                    <ModalSectionTitle>Pending Dues</ModalSectionTitle>
                                    <EditButton
                                        title="Edit Basic Detail"
                                        onClick={() => {
                                            setIsAddDuesModal(true);
                                        }}
                                    >
                                        Add Dues
                                    </EditButton>
                                </BtnWrapper>
                                <ModalSection>
                                    {totalPendingDueAmount === 0 ? (
                                        <NoDataMessage>No Pending Dues</NoDataMessage>
                                    ) : (
                                        <div className="space-y-2">
                                            <div className="space-y-2">
                                                {dues.map((due, index) => {
                                                    const subtitle =
                                                        `${due.rentStartDate ? moment(due.rentStartDate).format("DD MMM YY") :
                                                            '-'
                                                        } • ${due.rentEndDate ? moment(due.rentEndDate).format("DD MMM YY") : "-"}`;
                                                    return (
                                                        <FinancialCard
                                                            key={due.id}
                                                            title={
                                                                due.type === Config.dueType.OTHER
                                                                    ? capitalizeFirstLetter(due.title || due.label)
                                                                    : due.label
                                                            }
                                                            subtitle={subtitle}
                                                            amount={due.amount}
                                                            amountClass="text-red-600"
                                                            editable
                                                            editing={editingIndex === index}
                                                            editIcon={
                                                                <EditIcon
                                                                    className="ml-2"
                                                                    onClick={() =>
                                                                        handleEditClick(
                                                                            due.id,
                                                                            due.amount,
                                                                            index
                                                                        )
                                                                    }
                                                                >
                                                                    <FiEdit2 size={11} />
                                                                </EditIcon>
                                                            }
                                                            rightContent={
                                                                <div className="flex flex-col gap-2">
                                                                    <input
                                                                        type="number"
                                                                        value={editedValue}
                                                                        onChange={(e) => setEditedValue(e.target.value)}
                                                                        className="border rounded-lg px-3 py-2 w-24 text-right"
                                                                    />
                                                                    <button
                                                                        onClick={handleEditSubmit}
                                                                        className="bg-primary-color text-white rounded-lg py-1.5 text-xs"
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </div>
                                                            }
                                                        />
                                                    );
                                                })}

                                            </div>

                                            <SummaryItem
                                                title="Total Pending Dues"
                                                subtitle={
                                                    dues.length +
                                                    " outstanding dues "
                                                }
                                                amount={totalPendingDueAmount}
                                                color="text-red-500"
                                            />
                                        </div>
                                    )}
                                </ModalSection>
                                {/* </SectionBox> */}

                                {/* Security Adjusted Dues Section */}
                                {totalAdjustedDueAmount !== 0 &&
                                    <>
                                        <BtnWrapper>
                                            <ModalSectionTitle>Security Adjusted Dues</ModalSectionTitle>
                                        </BtnWrapper>
                                        <ModalSection>
                                            <div className="space-y-2">
                                                <div className="space-y-2">
                                                    {securityAdjusted.map((due) => (
                                                        <FinancialCard
                                                            key={due.id}
                                                            title={
                                                                due.type === Config.dueType.OTHER
                                                                    ? capitalizeFirstLetter(due.title || due.label)
                                                                    : due.label
                                                            }
                                                            subtitle={
                                                                `${due.rentStartDate ? moment(due.rentStartDate).format("DD MMM YY") :
                                                                    '-'
                                                                } • ${due.rentEndDate ? moment(due.rentEndDate).format("DD MMM YY") : "-"}`}
                                                            // badge="Adjusted from Security"
                                                            // badgeClass="bg-emerald-50 text-emerald-700 border border-emerald-100"
                                                            amount={Math.abs(due.amount)}
                                                            amountClass="text-emerald-700"
                                                        />

                                                    ))}

                                                </div>

                                                <SummaryItem
                                                    title="Total Security Adjusted"
                                                    subtitle={
                                                        securityAdjusted.length +
                                                        " adjusted " +
                                                        (securityAdjusted.length > 1 ? "charges" : "charge")
                                                    }
                                                    amount={totalAdjustedDueAmount}
                                                    color="text-primary-color"
                                                />
                                            </div>
                                        </ModalSection>
                                    </>
                                }
                                {/* Summary Section */}
                                <BtnWrapper>
                                    <ModalSectionTitle>Summary</ModalSectionTitle>
                                </BtnWrapper>
                                <ModalSection>
                                    <div className="space-y-3">

                                        <SummaryItem
                                            title="Security Paid"
                                            subtitle="Collected during move-in"
                                            amount={dueListData?.data?.data?.securityPaid}
                                            color="text-primary-color"
                                        />
                                        <SummaryItem
                                            title="Pending / Adjusted Dues"
                                            subtitle="Outstanding amount"
                                            amount={Math.abs(totalDues)}
                                            color="text-orange-600"
                                        />

                                        <SummaryItem
                                            title="Refund Amount"
                                            subtitle="Amount payable to tenant"
                                            amount={dueListData?.data?.data?.totalRefund || 0}
                                            color="text-emerald-700"
                                        />

                                    </div>
                                </ModalSection>
                                {dueListData?.data?.data?.settlementSummaryDoc &&
                                    <Value className="text-primary-color underline">
                                        <Link
                                            to={dueListData?.data?.data?.settlementSummaryDoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {dueListData?.data?.data?.settlementSummaryDoc?.split("/").pop()}
                                        </Link>
                                    </Value>}
                            </>
                        )}
                    </Wrapper>
                </ScrollableContent>

                <ActionSection>
                    <SideCancelBtn type="submit"
                        onClick={handleSubmit}
                        disabled={isGenerating}>
                        {isGenerating ? "Loading..." : "Generate"}
                    </SideCancelBtn>
                    <SubmitBtn
                        type="button"
                        disabled={isRefundDisabled}
                        onClick={() => {
                            if (dueListData?.data?.data?.totalRefund < 1) return;
                            if (isPayoutEnabled === Config.PAYOUT_ENABLED.YES) {
                                setIsFabOpen(true);
                            }
                            else {
                                setShowOfflineRefundModal(true);
                            }
                        }}
                        className={
                            dueListData?.data?.data?.totalRefund < 1
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                        }
                    >
                        Refund
                    </SubmitBtn>
                </ActionSection>
            </Content>

            <FabContainer>
                {/* Two buttons that appear above the FAB */}
                {isFabOpen && (
                    <div className="w-64 bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden">

                        {/* Header */}
                        <div className="px-4 py-3 border-b border-gray-100">
                            <p className="text-xs text-gray-500 uppercase tracking-wide">
                                Refund
                            </p>
                            <h3 className="text-sm font-semibold text-gray-800">
                                Choose Refund Method
                            </h3>
                        </div>

                        {/* Online Refund */}
                        <button
                            onClick={() => {
                                setIsFabOpen(false);
                                setShowOnlineRefundModal(true);
                            }
                            }
                            className="group flex items-start gap-3 w-full px-4 py-4 transition-all duration-200 hover:bg-gray-50"
                        >
                            <div className="p-2 rounded-lg bg-blue-50 group-hover:bg-blue-100 transition">
                                <MdOutlineAccountBalance size={18} className="text-primary-color" />
                            </div>

                            <div className="text-left">
                                <p className="text-sm font-semibold text-gray-800">
                                    Online Refund
                                </p>
                                <p className="text-xs text-gray-500">
                                    Transfer the refund directly to the tenant's bank account.
                                </p>
                            </div>
                        </button>

                        {/* Divider */}
                        <div className="h-px bg-gray-100 mx-3" />

                        {/* Offline Refund */}
                        <button
                            onClick={() => {
                                setIsFabOpen(false);
                                setShowOfflineRefundModal(true);
                            }
                            }
                            className="group flex items-start gap-3 w-full px-4 py-4 transition-all duration-200 hover:bg-gray-50"
                        >
                            <div className="p-2 rounded-lg bg-amber-50 group-hover:bg-amber-100 transition">
                                <MdOutlinePayments size={18} className="text-amber-600" />
                            </div>

                            <div className="text-left">
                                <p className="text-sm font-semibold text-gray-800">
                                    Offline Refund
                                </p>
                                <p className="text-xs text-gray-500">
                                    Refund via cash, UPI, bank transfer, or any payment made outside Kipinn.
                                </p>
                            </div>
                        </button>

                    </div>
                )}

            </FabContainer>

        </Container >
    );
};

const SummaryItem = ({ title, subtitle, amount, color }) => (
    <FinancialCard
        title={title}
        subtitle={subtitle}
        amount={amount}
        amountClass={color}
    />
);

const FinancialCard = ({
    title,
    subtitle,
    badge,
    badgeClass = "",
    amount,
    amountClass = "",
    editable = false,
    editing = false,
    editIcon,
    rightContent,
}) => {
    return (
        <Card>
            <CardLeft>
                <TitleRow>
                    <CardTitle>
                        {title}
                    </CardTitle>
                    {editable && editIcon}
                </TitleRow>

                {subtitle && (
                    <CardSubtitle>
                        {subtitle}
                    </CardSubtitle>
                )}

                {badge && (
                    <CardBadge className={badgeClass}>
                        {badge}
                    </CardBadge>
                )}
            </CardLeft>
            <CardRight>
                {editing
                    ? rightContent
                    : (
                        <CardAmount className={amountClass}>
                            ₹{Number(amount ?? 0)}
                        </CardAmount>
                    )}
            </CardRight>
        </Card>
    );
};

const Card = tw.div`
flex
justify-between
items-start
bg-white
border
border-gray-200
rounded-xl
px-4
py-3
hover:border-primary-color
transition-all
`;

const CardLeft = tw.div`
flex-1
`;

const CardRight = tw.div`
ml-4
`;

const TitleRow = tw.div`
flex
items-center
`;

const CardTitle = tw.div`
text-sm
font-medium
text-gray-800
`;

const CardSubtitle = tw.div`
text-xs
text-gray-500
mt-1
`;

const CardBadge = tw.span`
inline-flex
mt-2
rounded-full
px-2
py-0.5
text-[10px]
font-medium
`;

const CardAmount = tw.div`
text-base
font-semibold
`;

/* Styled Components */
const Wrapper = tw.div`grid gap-4 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;

const EditIcon = tw.span`text-gray-400 cursor-pointer text-sm hover:text-gray-600`

const NoDataMessage = tw.div`text-gray-500 text-center text-sm py-4`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;

const FabContainer = tw.div`
  fixed 
  bottom-20 
  right-6 
  md:right-10 
  flex 
  flex-col 
  items-end 
  z-10
`;

export default ViewFinalDues;